import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';

// 抑制ResizeObserver错误（这是一个无害的错误）
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation()
  }
})
import {
    Dropdown,
    Select,
    Tooltip,
    Link,
    Avatar,
    Badge,
    Input,
    Drawer,
    Tree,
    Notification
} from 'element-ui'
import './assets/style/theme/index.css' // element 自定义样式
import {requestUrl} from "./http/requestUrl";
import instance from "./http/http";
import ignore_auth_instance from "./http/http_ignore_auth";
import { isUseOpenData } from "@/assets/js/filterTree";
import {isAskLightning} from "@/assets/js/common";

import CKEditor from '@ckeditor/ckeditor5-vue2';
// 公用方法
import tool from './utils/common';
import { isLiBang } from './assets/js/accountMainId';




import VueI18n from 'vue-i18n'; //多语言

// 导入多语言的 JSON 文件
import enLocale from './locales/en.json';
import cnLocale from './locales/cn.json';

Vue.use(VueI18n);
// 创建 VueI18n 实例，并设置默认语言和多语言内容

let lang = 'cn';

Vue.prototype.main_isLishi = process.env.VUE_APP_SOURCE == 'lishi';
// Vue.prototype.main_isLishi = true;

if(window.location.origin == 'https://wisdom.ebot.isheely.com') {
  document.title = 'eKMS知识管理系统'
} else {
  if (Vue.prototype.main_isLishi) {
      document.title = 'AskKMS'
  } else {
      document.title = 'AskKMS知识管理系统'
  }
}

// 立时环境特殊处理
if (Vue.prototype.main_isLishi) {
  lang = 'en';
}

const i18n = new VueI18n({
    locale: lang, // 默认语言
    messages: {
      en: enLocale, // 英文
      cn: cnLocale, // 中文
      // 其他语言...
    }
  });


//把tools的工具挂载到vue原型上
import _lodash from "lodash";

Object.keys(tool).forEach(val => {
    Vue.prototype[val] = tool[val];
  })
Vue.config.productionTip = false

Vue.prototype.$http = instance;
Vue.prototype.$http_ignore_auth = ignore_auth_instance;
Vue.prototype.requestUrl = requestUrl;

Vue.prototype.ask_lodash = _lodash;
Vue.prototype._isLiBang = isLiBang;

// 文件类型图标
Vue.prototype.askSetSrc = (type) => {
  if (type === 'mp4' || type === 'MP4' || type === 'mov' || type === 'MOV' || type == 'avi' || type == 'flv') {
    return 'video'
  } else if (type === 'jpg' || type === 'png' || type === 'JPG' || type === 'PNG' ||
    type === 'jpeg' || type === 'JPEG' || type === 'gif' || type === 'bmp' ||
    type === 'BMP' || type === 'WebP' || type === 'webp' || type === 'svg' || type === 'SVG' || type === 'rgb' || type === 'heic') {
    return 'image'
  } else if (type === 'doc' || type === 'docx' || (type && type.includes('文档'))) {
    return 'word'
  } else if (type === 'pdf') {
    return 'pdf'
  } else if (type === 'ppt' || type === 'pptx') {
    return 'ppt'
  } else if (type === 'xlsx' || type === 'xls') {
    return 'excel'
  } else if (type === 'txt') {
    return 'txt'
  } else if (type === 'mp3' || type === 'MP3') {
    return 'audio'
  } else {
    return type
  }
}

Vue.use(Dropdown);
Vue.use(Select);
Vue.use(Tooltip);
Vue.use(Link);
Vue.use(Avatar);
Vue.use(Badge);
Vue.use(Input);
Vue.use(Drawer);
Vue.use(Tree);
Vue.use(Notification);
Vue.use(CKEditor)

// 存储通知的 onClick 处理函数，key 是通知的唯一标识（title + message + timestamp）
const notificationClickHandlers = new Map()

// 拦截 Element UI 通知，防止弹出空白卡片，并支持 onClick
const patchNotification = (notifyFn) => {
  if (typeof notifyFn !== 'function') {
    return notifyFn
  }

  const patched = function patchedNotification(options = {}) {
    if (typeof options === 'string') {
      options = { title: options }
    } else if (!options || typeof options !== 'object') {
      return notifyFn.call(this, options)
    }

    console.debug('[notify] 调用参数:', options)
    console.debug('[notify] 调用堆栈:', new Error().stack)

    const trimmedTitle = typeof options.title === 'string' ? options.title.trim() : options.title
    const trimmedMessage = typeof options.message === 'string' ? options.message.trim() : options.message

    const hasTitle = typeof trimmedTitle === 'string' ? trimmedTitle.length > 0 : !!trimmedTitle
    const hasMessage = typeof trimmedMessage === 'string' ? trimmedMessage.length > 0 : !!trimmedMessage

    if (!hasTitle && !hasMessage) {
      console.warn('[notify] 阻止空白通知弹窗:', options)
      return
    }

    const normalizedClass = options.customClass
      ? `${options.customClass} has-content-notify`
      : 'has-content-notify'

    // 保存 onClick 处理函数（如果提供）
    const onClickHandler = options.onClick
    const notificationId = options._notificationId // 从 options 中提取 notificationId
    const timestamp = Date.now()
    const notificationKey = `${trimmedTitle || ''}::${trimmedMessage || ''}::${timestamp}`

    // 移除 onClick 和 _notificationId，因为 Element UI 不支持
    // eslint-disable-next-line no-unused-vars
    const { onClick, _notificationId, ...notifyOptions } = options

    const instance = notifyFn.call(this, { 
      ...notifyOptions, 
      title: trimmedTitle, 
      message: trimmedMessage, 
      customClass: normalizedClass 
    })

    // 如果有 onClick 处理函数，保存它
    if (onClickHandler && typeof onClickHandler === 'function') {
      notificationClickHandlers.set(notificationKey, {
        handler: onClickHandler,
        instance: instance,
        title: trimmedTitle,
        message: trimmedMessage,
        timestamp: timestamp,
        notificationId: notificationId // 保存 notificationId
      })
      
      // 设置一个标记，用于在 DOM 中识别这个通知
      if (instance && typeof instance === 'object') {
        instance._notificationKey = notificationKey
      }
    }

    if (instance && typeof instance === 'object') {
      const instanceTitle = typeof instance.title === 'string' ? instance.title.trim() : instance.title
      const instanceMessage = typeof instance.message === 'string' ? instance.message.trim() : instance.message
      const hasInstanceTitle = typeof instanceTitle === 'string' ? instanceTitle.length > 0 : !!instanceTitle
      const hasInstanceMessage = typeof instanceMessage === 'string' ? instanceMessage.length > 0 : !!instanceMessage

      if (!hasInstanceTitle && !hasInstanceMessage && typeof instance.close === 'function') {
        console.warn('[notify] 关闭实例化后的空白通知:', instance)
        instance.close()
      }
    }

    return instance
  }

  patched.close = notifyFn.close ? notifyFn.close.bind(notifyFn) : undefined
  patched.closeAll = notifyFn.closeAll ? notifyFn.closeAll.bind(notifyFn) : undefined
  return patched
}

Vue.prototype.$notify = patchNotification(Vue.prototype.$notify)

// 覆盖全局 Notification 函数（直接使用导入的 Notification(...) 时也生效）
const patchedGlobalNotification = patchNotification(Notification)
Vue.prototype.$ELEMENT_NOTIFICATION = patchedGlobalNotification

if (typeof window !== 'undefined' && typeof MutationObserver !== 'undefined') {
  const notificationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
          return
        }

        const notifications = node.classList.contains('el-notification')
          ? [node]
          : Array.from(node.querySelectorAll('.el-notification'))

        notifications.forEach((el) => {
          const titleEl = el.querySelector('.el-notification__title')
          const contentEl = el.querySelector('.el-notification__content')
          const titleText = titleEl ? titleEl.textContent.trim() : ''
          const contentText = contentEl ? contentEl.textContent.trim() : ''

          console.debug('[notify] 监听到通知节点:', { titleText, contentText, outerHTML: el.outerHTML })

          if (!titleText && !contentText) {
            console.warn('[notify] DOM 级清理空白通知:', el)
            el.parentNode && el.parentNode.removeChild(el)
            return
          }

          // 如果通知还没有添加点击事件，尝试匹配并添加
          if (!el.dataset.clickHandlerAdded && titleText) {
            // 查找匹配的 onClick 处理函数（通过标题匹配，优先匹配最近的）
            let matchedHandler = null
            let matchedKey = null
            let matchedHandlerInfo = null
            
            // 从最新的开始查找（时间戳最大）
            const handlers = Array.from(notificationClickHandlers.entries())
              .sort((a, b) => b[1].timestamp - a[1].timestamp)
            
            for (const [key, handlerInfo] of handlers) {
              if (handlerInfo.title === titleText && !handlerInfo.bound) {
                matchedHandler = handlerInfo.handler
                matchedKey = key
                matchedHandlerInfo = handlerInfo
                handlerInfo.bound = true // 标记已绑定，避免重复绑定
                // 保存 handlerInfo 供 clickHandler 使用
                handlerInfo.element = el
                break
              }
            }

            // 如果找到匹配的处理函数，添加点击事件
            if (matchedHandler && matchedHandlerInfo) {
              el.dataset.clickHandlerAdded = 'true'
              el.style.cursor = 'pointer'
              
              // 保存 notificationId 和 handler 供点击事件使用
              const notificationId = matchedHandlerInfo.notificationId
              
              const clickHandler = (e) => {
                // 排除关闭按钮的点击
                if (e.target.closest('.el-notification__closeBtn')) {
                  return
                }
                if (process.env.NODE_ENV !== 'production') {
                  console.debug('[notify] 点击通知卡片:', { title: titleText, key: matchedKey, notificationId: notificationId })
                }
                
                // 直接调用处理函数，让它自己处理上下文问题
                // 或者如果 handler 无法正常工作，直接触发全局事件
                try {
                  matchedHandler.call(null, e)
                } catch (error) {
                  console.error('[notify] 调用 onClick 处理函数失败:', error)
                  // 如果调用失败，直接触发全局事件
                  if (notificationId && typeof window !== 'undefined') {
                    const event = new CustomEvent('notification:open-center', {
                      detail: { notificationId: notificationId }
                    })
                    window.dispatchEvent(event)
                  }
                }
              }
              
              el.addEventListener('click', clickHandler)
              
              // 清理：当通知被移除时，从 Map 中删除对应的处理函数
              const cleanupObserver = new MutationObserver(() => {
                if (!document.body.contains(el)) {
                  if (matchedKey) {
                    notificationClickHandlers.delete(matchedKey)
                  }
                  cleanupObserver.disconnect()
                }
              })
              cleanupObserver.observe(document.body, { childList: true, subtree: true })
              
              // 10秒后自动清理（通知通常会自动关闭）
              setTimeout(() => {
                if (matchedKey) {
                  notificationClickHandlers.delete(matchedKey)
                }
              }, 10000)
            }
          }
        })
      })
    })
  })

  notificationObserver.observe(document.body, { childList: true, subtree: true })
}
/* 路由发生变化修改页面title */
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })
Vue.prototype.isUseOpenData = isUseOpenData
Vue.prototype.isAskLight = isAskLightning
Date.prototype.Format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
new Vue({
    router,
    store,
    i18n,
  render: h => h(App)
}).$mount('#app')
